import script from "./ChatView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatView.vue?vue&type=script&setup=true&lang=ts"

import "./ChatView.vue?vue&type=style&index=0&id=765bd389&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-765bd389"]])

export default __exports__